import React, { useState } from 'react'
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/fontawesome-free-solid'

// Selettore delle "altre dimensioni" per decidere quali mostrare o meno. E' un blocchetto con una lista di checkbox per dire "questa si/questa no"
export function DimensionSelector({otherDimensions, dimensionsFilter, onToggle}) {
  const [showDimensionSelector, setShowDimensionSelector] = useState(false)
  const [checked, setChecked] = useState(false)
  // Funzione per chiudere il modale. Verrà passata alla prop `toggle`.
  const toggleModal = () => {
    setShowDimensionSelector(false);
  };

  return (
    <>
      <h3>
        ALTRE DIMENSIONI{' '}
        <FontAwesomeIcon
          style={{cursor: 'pointer'}}
          icon={faCog}
          onClick={() => setShowDimensionSelector(!showDimensionSelector)}
        />
      </h3>
      <Modal isOpen={showDimensionSelector} toggle={toggleModal} centered>
        {/* ModalHeader aggiunge un titolo e un pulsante di chiusura (la 'X') */}
        <ModalHeader toggle={toggleModal}>
          <h3>Seleziona Dimensioni da Visualizzare</h3>
        </ModalHeader>

        {/* ModalBody contiene il corpo del modale, nel nostro caso la form */}
        <ModalBody>
          <Form className={'dimension-selector'}>
            {otherDimensions.map((d) => (
              <FormGroup check>
                <Input
                  type="checkbox"
                  name={d.display_name}
                  className="mr-2"
                  onChange={(e) => onToggle(d, e.target.checked)}
                  checked={dimensionsFilter.includes(d.display_name)}
                />
                <Label check>
                  {d.display_name}
                </Label>
              </FormGroup>
            ))}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleModal}>
            Fatto
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}